<template>
  <div class="contain">
    <!-- 轮播图 -->
    <el-carousel :interval="4000" type="card">
      <el-carousel-item v-for="(item, index) in images" :key="index">
        <img
          class="medium imgs"
          :src="item.cover_url"
          alt=""
          @click="goMatchDetails(item.link_type, item.link_to)"
        />
      </el-carousel-item>
    </el-carousel>
    <!-- 分类 -->
    <div class="tab">
      <div
        class="tab-box"
        v-for="(item, index) in tab"
        :key="index"
        @click="clickTab(index)"
      >
        <div class="tab-box-item" :class="active == index ? 'active' : ''">
          {{ item.title }}
        </div>
        <div
          class="tab-box-line"
          :style="{ background: active == index ? '#3D7EFF' : '' }"
        ></div>
      </div>
    </div>
    <!-- 比赛 -->
    <div
      class="match"
      v-loading="loading"
      customClass="loadingClass"
      element-loading-text="拼命加载中"
    >
      <div
        class="match-box"
        v-for="(item, index) in list"
        :key="index"
        @click="goMatchDetails('1', item.id)"
      >
        <img class="img" :src="item.cover" alt="" />
        <div class="match-box-item">
          <!-- 比赛 -->
          <div class="match-box-item-top">
            <img :src="item.logo" alt="" />
            <div class="match-box-item-right">
              <div class="match-box-item-right-name">{{ item.name }}</div>
              <div class="match-box-item-right-msg">
                <div>{{ item.enroll_num }}人已报名</div>
                <!-- <div>2.3km</div> -->
              </div>
            </div>
          </div>
          <!-- 比赛时间和地址 -->
          <div class="match-box-item-tomeOrAddress">
            <div class="match-box-item-tomeOrAddress-box">
              <img src="../../assets/image/matchDate.png" alt="" />
              <span>{{ item.start_at }} 开赛</span>
            </div>
            <div class="match-box-item-tomeOrAddress-box">
              <img src="../../assets/image/matchAddress.png" alt="" />
              <div class="_venue">
                {{ item.venue }}
              </div>
            </div>
          </div>

          <!-- 比赛时间和地址 -->
          <div class="match-box-item-operation">
            <div
              class="match-box-item-operation-box"
              @click.stop="getRewards(item.id)"
            >
              <img src="../../assets/image/reward.png" alt="" />
              <span>奖励详情</span>
            </div>
            <div
              class="match-box-item-operation-btn"
              :style="{
                background:
                  item.is_enroll == 1 ||
                  item.status == 1 ||
                  item.status == 3 ||
                  item.status == 4
                    ? '#B4B4B4'
                    : item.status == 5
                    ? '#F24342'
                    : '',
              }"
              @click.stop="enroll(item.id, item.status)"
            >
              <span>{{
                item.status == 1
                  ? "未开始"
                  : item.status == 2 && item.is_enroll == 1
                  ? "已报名"
                  : item.status == 2
                  ? "立即报名"
                  : item.status == 3
                  ? "报名结束"
                  : item.status == 4
                  ? "进行中"
                  : item.status == 5
                  ? "已结束"
                  : ""
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载到底 -->
    <p class="noMore" v-if="noMore && list.length != 0">已经到底了~</p>
    <!-- 无数据 -->
    <div class="nodata" v-if="list.length == 0 && !loading">
      <img src="../../assets/image/noMatch.png" alt="" />
      <span>暂无比赛</span>
    </div>
    <!-- 奖励详情 -->
    <el-dialog
      custom-class="dialog"
      :visible.sync="dialogVisible"
      width="22%"
      :show-close="false"
    >
      <div class="reward">
        <!-- 奖励标题 -->
        <div class="reward-title">
          <img src="../../assets/image/reward.png" alt="" />
          <span>奖励详情</span>
        </div>
        <!-- 奖励内容 -->
        <div class="reward-content">
          <div
            class="reward-content-box"
            v-for="(item, index) in rewards"
            :key="index"
          >
            <div>{{ item.ranking }}战队：</div>
            <div>{{ item.award }}</div>
          </div>
        </div>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      custom-class="dialog"
      :visible.sync="code"
      width="15%"
      center
    >
      <span>请先创建该赛事类型的战队</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="code = false">取 消</el-button>
        <el-button type="primary" @click="goCreateTeam">前往</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      noMore: false,
      loading: true,
      images: [],
      dialogVisible: false,
      active: 0,
      tab: [
        {
          title: "全部",
        },
        {
          title: "报名中",
        },
        {
          title: "报名结束",
        },
        {
          title: "进行中",
        },
        {
          title: "已结束",
        },
      ],
      status: "",
      list: [],
      rewards: [],
      query: {
        page: 1,
        limit: 10,
        status: "",
      },
      code: false,
    };
  },
  created() {
    if (this.$store.getters.getUserInfo.student_id) {
      this.getBanners();
      this.getList();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll2); // 监听（绑定）滚轮滚动事件
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll2); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    goCreateTeam() {
      this.$router.push("/mine/my_match/my_team");
    },
    // 滚动触底触发事件
    handleScroll2() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if (!this.noMore) {
          console.log("触底");
          this.query.limit += 10;
          this.getList();
        }
      }
    },
    // 比赛列表
    getList() {
      this.noMore = false;
      this.loading = true;
      request({
        url: "/api/userend/match/list",
        method: "get",
        params: this.query,
      }).then((response) => {
        this.list = response.data;
        if (this.list.length < this.query.limit) {
          this.noMore = true;
        }
        this.loading = false;
      });
    },
    // 轮播图
    getBanners() {
      request({
        url: "/api/userend/banners",
        method: "get",
        params: { category_id: 2 },
      }).then((response) => {
        this.images = response.data.data;
      });
    },
    // 比赛报名
    enroll(id, status) {
      if (status != 2) {
        return;
      }
      this.code = false;
      request({
        url: "/api/userend/match/enroll",
        method: "post",
        params: { match_id: id },
      })
        .then((response) => {
          this.$message.success("报名成功");
        })
        .catch((err) => {
          console.log(err);
          if (err == "请先创建该赛事类型的战队") {
            this.code = true;
          }
        });
    },
    // 比赛奖励
    getRewards(id) {
      request({
        url: "/api/userend/match/detail",
        method: "get",
        params: { id: id },
      }).then((response) => {
        this.rewards = response.data.rewards;
        this.dialogVisible = true;
      });
    },
    // 前往详情
    goMatchDetails(type, id) {
      if (type == "1") {
        this.$router.push({
          path: "/match/details",
          query: {
            id: id,
          },
        });
      }
    },
    clickTab(index) {
      this.active = index;
      if (index == 0) {
        this.query.status = "";
      } else {
        this.query.status = index + 1;
      }
      this.getList();
    },
    goRewardDetails() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss">
.imgs {
  width: 100%;
  border-radius: 8px;
}
.el-carousel__container {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .el-carousel__item {
    overflow: hidden;
    border-radius: 8px;
  }
}
.contain {
  .dialog {
    border-radius: 20px;
  }
  .reward {
    padding: 20px;
    .reward-title {
      margin-bottom: 15px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c65e00;
        margin-left: 8px;
      }
    }
    .reward-content {
      padding: 0 15px 18px 15px;
      border-radius: 12px;
      border: 1px solid #f9fafd;
      .reward-content-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 20px;
        div {
          &:nth-child(1) {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
            line-height: 22px;
            white-space: nowrap;
          }
          &:nth-child(2) {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
            line-height: 22px;
          }
        }
      }
    }
    .el-button {
      margin-top: 30px;
      width: 100%;
      height: 50px;
      background: #3d7eff;
      border-radius: 6px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .tab {
    margin-top: 25px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .tab-box {
      cursor: pointer;
      .tab-box-item {
        padding: 0 25px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #858585;
        margin-bottom: 6px;
      }
      .active {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3d7eff;
      }
      .tab-box-line {
        width: 40px;
        height: 4px;
        // background: #3D7EFF;
        margin: 0 auto;
        border-radius: 2px;
      }
    }
    margin-bottom: 25px;
  }
  .noMore {
    text-align: center;
    padding: 5px 0 15px 15px;
  }
  .nodata {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 357px;
      height: 300px;
    }
    span {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
  }
  .el-loading-spinner {
    // margin-top: 20px;
    position: relative;
    top: 60px;
    right: 0;
  }
  .match:after {
    display: block;
    content: "";
    width: 30%;
    height: 0px;
  }
  .match {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .match-box {
      width: 30%;
      border-radius: 8px;
      background: #ffffff;
      cursor: pointer;
      margin-bottom: 2%;
      // flex:0 0 32%;
      // margin-right:2%;
      // .match-box:nth-of-type(3n){
      //     margin-right:0;
      // }
      .img {
        width: 100%;
        height: 260px;
        border-radius: 8px 8px 0px 0px;
      }
      .match-box-item {
        padding: 20px;
        .match-box-item-top {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          img {
            width: 86px;
            height: 59px;
            border-radius: 4px;
          }
          .match-box-item-right {
            margin-left: 15px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .match-box-item-right-name {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1e2134;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .match-box-item-right-msg {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              div {
                &:nth-child(1) {
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #3d7eff;
                }
                &:nth-child(2) {
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #506176;
                }
              }
            }
          }
        }
        .match-box-item-tomeOrAddress {
          margin-top: 20px;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .match-box-item-tomeOrAddress-box {
            width: 46%;
            // padding: 0 50px;
            height: 46px;
            border-radius: 4px;
            border: 1px solid #f9fafd;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
            }
            ._venue {
              width: 200px;
              //   height:20px;
              overflow: hidden;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            span,
            div {
              display: inline-block;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #506176;
              margin-left: 6px;
            }
          }
        }
        .match-box-item-operation {
          margin-top: 20px;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .match-box-item-operation-box {
            cursor: pointer;
            width: 46%;
            // padding: 0 50px;
            height: 46px;
            border-radius: 6px;
            border: 1px solid #f9fafd;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #506176;
              margin-left: 6px;
            }
          }
          .match-box-item-operation-btn {
            cursor: pointer;
            width: 46%;
            text-align: center;
            height: 46px;
            background: #3d7eff;
            border-radius: 6px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 46px;
          }
        }
      }
    }
  }
}
.el-carousel__item:nth-child(2n) {
  overflow: hidden;
}

.el-carousel__item:nth-child(2n + 1) {
  overflow: hidden;
}
</style>